module.exports = __webpack_public_path__ + "assets/img/PC6.90962e7e.jpg";